import { FilterBar } from "@kohler-dsm-library/kohler-core"
import { sortUiPropTypes } from "@/propTypes/plp"

const SortUI = ({ propsSortUI = {} }) => {
  return <FilterBar {...propsSortUI} />
}

SortUI.propTypes = sortUiPropTypes

export default SortUI
